import React from 'react';

import Alert from 'react-bootstrap/Alert';

class Error extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    show: true
	};
    }
    
    render() {
	return (
	    <Alert variant="danger" onClose={() => this.setState({show: false})} dismissible>
		{this.props.error.message}
	    </Alert>
	);
    }
}

export default Error;
